import React, { FC, ReactNode, useState } from 'react';
import { GetStartedActionsContext } from './context';
import { DepartmentFormType } from 'pages/get-started/add-department';
import { FileDetailsType } from 'pages/get-started/add-your-team/add-csv-file';
import { ActiveType } from 'pages/get-started/add-your-team';
import { BranchAddressLocationType } from 'models/branch-address.model';
import { OperatingDaysFormDataType } from 'models/operating-day.model';
import { AddBrandType } from 'models/brand.model';
import { ENUM_WORK_MODES } from 'utils/enum';

const GetStartedActionProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [showTransferModal, setshowTransferModal] = useState(false);
  const [departmentFormData, setDepartmentFormData] = useState<DepartmentFormType[]>([]);
  const [teamDataForm, setTeamDataForm] = useState<FileDetailsType[]>([]);
  const [workModes, setWorkModes] = useState([] as ENUM_WORK_MODES[]);
  const [brandFormData, setBrandFormData] = useState<AddBrandType>({
    name: '',
    images: [],
    cokitchen_id: ''
  });
  const [addressesFormData, setAddressesFormData] = useState<BranchAddressLocationType[]>([
    { address: '', latitude: 0, longitude: 0 }
  ]);
  const [operatingDays, setOperatingDays] = useState<OperatingDaysFormDataType>({
    days: [
      { day: 1, is_active: false },
      { day: 2, is_active: false },
      { day: 3, is_active: false },
      { day: 4, is_active: false },
      { day: 5, is_active: false },
      { day: 6, is_active: false },
      { day: 7, is_active: false }
    ]
  });
  const [isDisabled, setIsDisabled] = useState(false);
  const [isFormEmpty, setIsFormEmpty] = useState(true);
  const [active, setActive] = useState<ActiveType | null>(null);

  return (
    <GetStartedActionsContext.Provider
      value={{
        showTransferModal,
        setshowTransferModal,
        departmentFormData,
        setDepartmentFormData,
        teamDataForm,
        setTeamDataForm,
        isDisabled,
        setIsDisabled,
        isFormEmpty,
        setIsFormEmpty,
        active,
        setActive,
        brandFormData,
        setBrandFormData,
        addressesFormData,
        setAddressesFormData,
        operatingDays,
        setOperatingDays,
        workModes,
        setWorkModes
      }}>
      {children}
    </GetStartedActionsContext.Provider>
  );
};

export default GetStartedActionProvider;
